export default __webpack_public_path__ + "static/media/studentModalVideoCourse.042c4254.svg";